import React from "react";
import Emblem from "./Emblem";

export function BrandSplash({ text = "Loading… Akwaaba" }) {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col justify-between bg-crimson text-parchment" role="status" aria-live="polite" data-testid="brand-splash">
      <div className="kente-border" style={{ height: 6 }} />
      <div className="flex flex-1 flex-col items-center justify-center p-6 text-center">
        <div className="announce-drum flex h-[120px] w-[120px] items-center justify-center rounded-full bg-parchment shadow-[0_0_0_10px_rgba(217,155,38,0.25)]"><Emblem size={96} /></div>
        <p className="mt-5 font-serif-display text-2xl font-bold text-gold-bright">Okuapemman Association</p>
        <p className="eyebrow mt-1 text-parchment/85">of Massachusetts</p>
        <div className="mt-6 flex gap-2">{[0, 1, 2].map((i) => <span key={`d${i}`} className="h-2.5 w-2.5 animate-bounce rounded-full bg-gold" style={{ animationDelay: `${i * 150}ms` }} />)}</div>
        <p className="mt-3 text-sm italic text-parchment/80">{text}</p>
      </div>
      <div className="kente-border" style={{ height: 6 }} />
    </div>
  );
}
